import { TableRow } from '@mui/material';

import withStyles from '@mui/styles/withStyles';

const styles = /* istanbul ignore next */ ({ palette }) => ({
  root: {
    borderBottom: `1px solid ${palette.layout.line.divider}`,
  },
  head: {
    outline: 'none !important',
    borderBottom: `2px solid ${palette.layout.line.divider}`,
  },
});

export default withStyles(styles)(TableRow);
